import React, { useEffect, useState } from "react";
import { getPreviousMeasurements } from "../../../services/firebase/firestore/getData";
import "./SidebarInfo.scss";

export default function SidebarInfo({ selected_client, currentTime }) {
  const [oldMeasurements, setPreviousMeasurements] = useState(false);

  useEffect(() =>{
    if(selected_client) {
      getPreviousMeasurements(selected_client, currentTime, (result) => {
        setPreviousMeasurements(result);
      });
    }
  }, [selected_client.id]);

  return(
      <div className="c-content c-measurements">
          <div className="c-content c-client-side-info c-client-side-info-weight">
            {selected_client?.measurements?.weight ? selected_client.measurements.weight : ""} kg
            {/* <p>{oldMeasurements[0]?.weight ? oldMeasurements[0].weight : "??"} kg</p> */}
          </div>
          <div className="c-content c-client-side-info c-client-side-info-length">
            {selected_client?.measurements?.length ? selected_client.measurements.length : ""} cm
          </div>
          {selected_client?.measurements?.bodyfat ? (
          <div className="c-content c-client-side-info c-client-side-info-fat">
            {selected_client?.measurements?.bodyfat ? selected_client.measurements.bodyfat : ""} %
            {/* <p>{oldMeasurements[0]?.bodyfat ? oldMeasurements[0].bodyfat : "??"}% bodyfat</p> */}
          </div> ) : <></>}
          {selected_client?.measurements?.bmi ? (
            <div className="c-content c-client-side-info c-client-side-info-bmi">
               { selected_client.measurements.bmi } BMI
              {/* <p>{oldMeasurements[0]?.bmi ? oldMeasurements[0].bmi : "??"} bmi</p> */}
            </div> ) : <></>}
      </div>
  );
}